import React, { useEffect, useRef } from 'react';
import { Container, Wrapper, Title, Paragraph, Button, Image } from '../../library/components';
import PuntoMujer from '../../assets/punto_mujer.png';
import Nutrit from '../../assets/nutrit.png';
import Atajos from '../../assets/atajos.png';
import PlayStore from '../../assets/play-store.png';
import Slider from "react-slick";
import styled from 'styled-components';

const FullWrapper = styled.div`
    padding: 4rem 0;
    max-width: 90%;
    margin: auto;
`;

const Clients = () => {
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        <FullWrapper>
            <Slider {...settings}>
                <div className="m-flex">
                    <Container style={{margin: 0}} align="flex-start" background="#C8F8FF">
                        <Title size="22px" color="#0189D1">Nuestros Trabajos</Title>
                        <Title size="56px" color="2B292D">Punto Mujer<br/>Córdoba</Title>
                        <Paragraph>
                            Una herramienta práctica y gratuita<br/>para alertar a tu círculo de confianza<br/>cuando te sientas en peligro, para dar<br/>a conocer tu ubicación o comunicarte<br/>con la policía. Brinda además,<br/>información útil vinculada a<br/>situaciones de violencia.
                        </Paragraph>
                        <Button width="160px" primary onClick={() => window.location.replace('https://play.google.com/store/apps/details?id=ar.gov.cba.puntomujer')}>Descargar</Button>
                        <Image className="m-display" width="100%" height="auto" src={PlayStore} />
                    </Container>
                    <Container className="m-none" style={{margin: 0}} background="#C8F8FF">
                        <Image width="100%" height="auto" src={PuntoMujer} />
                    </Container>
                </div>
                <div className="m-flex">
                    <Container style={{margin: 0}} align="flex-start" background="#C8F8FF">
                        <Title size="22px" color="#0189D1">Nuestros Trabajos</Title>
                        <Title size="56px" color="2B292D">otro<br/>otro</Title>
                        <Paragraph>
                            algo.
                        </Paragraph>
                        <Button width="160px" primary onClick={() => window.location.replace('https://play.google.com/store/apps/details?id=ar.gov.cba.puntomujer')}>Descargar</Button>
                        <Image className="m-display" width="100%" height="auto" src={PlayStore} />
                    </Container>
                    <Container className="m-none" style={{margin: 0}} background="#C8F8FF">
                        <Image width="100%" height="auto" src={PuntoMujer} />
                    </Container>
                </div>
            </Slider>
        </FullWrapper>
    )
}

export default Clients;